import React from "react";

interface DimensionFillProps {
  className?: string;
}

const DimensionFill: React.FC<DimensionFillProps> = ({ className }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.5 0.5L1 3L3.5 5.5M6.5 0.5L9 3L6.5 5.5"
        stroke="#1E293B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DimensionFill;
